import { useMutation } from 'react-query'
import { useErrorReporter } from 'Hooks/useErrorReporter'
import { usePeoplePageContext } from 'Contexts/PeoplePageContext'

import { QueryNames } from 'Hooks/api/queryNames'
import { useEmployerUsersContext, EmployerActionTypes } from 'Contexts/EmployerUsersContext'
import { UserRole } from 'Utils/types/roles'

import { revokeUserAdminPermissions } from 'Services/users/userService'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'

export const useRevokeUserAdminPermissions = () => {
  const reportError = useErrorReporter()

  const { setModal, setActionableUserId } = usePeoplePageContext()
  const { dispatch } = useEmployerUsersContext()

  return useMutation([QueryNames.RevokeUserAdminPermissions], revokeUserAdminPermissions, {
    onSuccess: (response, parameters) => {
      toast.success(AppNotification.UserPermissionsUpdatedSuccessful)
      setModal(undefined)
      setActionableUserId(undefined)
      dispatch({
        type: EmployerActionTypes.RemoveRoles,
        value: { id: parameters.userId, roles: [UserRole.EMPLOYERADMIN] }
      })
    },
    onError: (err: string) => {
      reportError(`useRevokeUserAdminPermissions error: ${err}`)
    }
  })
}
